var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPatinete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81994 21H14.9999V20C14.9999 17.79 16.7899 16 18.9999 16H19.7399L17.8399 3.56C17.6299 2.65 16.8199 2 15.8899 2H12.9999C12.4477 2 11.9999 2.44772 11.9999 3C11.9999 3.55228 12.4477 4 12.9999 4H15.8899L17.2899 14.25H17.2799C15.1199 14.9 13.4699 16.73 13.0899 19H7.81994C7.33994 17.66 5.95994 16.76 4.39994 17.06C3.21994 17.29 2.26994 18.26 2.04994 19.44C1.69994 21.34 3.15994 23 4.99994 23C6.29994 23 7.39994 22.16 7.81994 21ZM4.99994 21C4.44994 21 3.99994 20.55 3.99994 20C3.99994 19.45 4.44994 19 4.99994 19C5.54994 19 5.99994 19.45 5.99994 20C5.99994 20.55 5.54994 21 4.99994 21Z",
    fill: "#1C1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17C17.34 17 16 18.34 16 20C16 21.66 17.34 23 19 23C20.66 23 22 21.66 22 20C22 18.34 20.66 17 19 17ZM19 21C18.45 21 18 20.55 18 20C18 19.45 18.45 19 19 19C19.55 19 20 19.45 20 20C20 20.55 19.55 21 19 21Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPatinete);
export default __webpack_public_path__ + "static/media/Ic_ patinete.96c173b129f60d06b0c08d8348722c44.svg";
export { ForwardRef as ReactComponent };